import { memo } from "react";
import { GalleryVideoObject } from "../Galleries/utils/utils";
import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import styles from "./Gallery.module.scss";

type GalleryVideoProps = {
  video: GalleryVideoObject;
  index: number;
  total: number;
  onSelect: (index: number) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
};

export const GalleryVideo = memo(function GalleryVideo({
  video,
  index,
  total,
  onSelect,
  onKeyDown,
}: GalleryVideoProps) {
  return (
    <button
      className={styles.videoButton}
      onClick={() => onSelect(index)}
      type="button"
      aria-label={`Play video ${index + 1} of ${total}, ${video.title}`}
      data-testid={`gallery:video-${index}`}
      onKeyDown={onKeyDown}
    >
      <img
        src={formatAmplienceImageURL(`${video.imageUrl}?wid=720&hei=640`)}
        alt=""
        className={styles.image}
        loading="lazy"
      />
    </button>
  );
});
